import { render, staticRenderFns } from "./sidebar-QRcode-com.vue?vue&type=template&id=dc6ff884&scoped=true&"
import script from "./sidebar-QRcode-com.vue?vue&type=script&lang=js&"
export * from "./sidebar-QRcode-com.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-QRcode-com.vue?vue&type=style&index=0&id=dc6ff884&scoped=true&lang=scss&"
import style1 from "./sidebar-QRcode-com.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6ff884",
  null
  
)

export default component.exports